import API_URLS from "constants/apis.url";

import { deleteRequest, getRequest, postRequest, putRequest } from "./api";

export const addSystem = async payload => await postRequest(API_URLS.adminSystemsURL, payload, true);
export const getSystems = async () => await getRequest(API_URLS.systemsURL, false);
export const editSystem = async payload => await putRequest(`${API_URLS.adminSystemsURL}/${payload["SysId"]}`, payload, true);
export const downloadMetadata = async sysId => await getRequest(`${API_URLS.adminSystemsURL}/${sysId}/metadata`, false);
export const deleteSystem = async system => await deleteRequest(`${API_URLS.adminSystemsURL}/${system["SysId"]}`, system, true);
